<template>
  <div id="table-index">
    <div
      :class="{ content: header != 'ข้อมูลใบคำขอ' }"
      style=" padding-top:40px;padding-bottom:40px;"
    >
      <slot name="search-box"></slot>

      <div class="col-xs-12 clear">
        <section class="panel panel-default">
          <div class="panel-heading">
            <h4>{{ header }}</h4>
          </div>

          <div style="padding: 12px 0px;">
            <slot name="search"></slot>
          </div>

          <slot name="group"></slot>

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th v-for="(column, index) in columns" :key="`${header}-${index}`">
                    {{ column }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <slot name="main"></slot>
              </tbody>
            </table>
          </div>

          <slot name="paginate"></slot>
        </section>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableIndex',
  props: ['header', 'columns'],
}
</script>

<style lang="scss">
.tab_panel > li.active > a {
  background-color: transparent !important;
  color: black !important;
  border-bottom: 4px solid black;
  border-radius: 0px;
  font-weight: bolder;
}
.tab_panel > li > a {
  padding: 9px 22px !important;
}
</style>
